import Analytics from '../src/Analytics/index.tsx';
export default Analytics;
